export default __webpack_public_path__ + "static/jobBg-fa4f9a060ac51a8a27b89c04fe066029.jpg";